const login = {
  title: "Welcome to MERU",
  email: "Email",
  password: "Password",
  loginbtn: "Log In",
  messages: {
    info:
      "You will receive an email with the instructions to recover your password",
    email: {
      required: "E-mail is required",
      valid: "Invalid E-mail"
    },
    password: {
      required: "Password is required",
      valid: "Password at 8 characters",
      recover: "RESET PASSWORD",
      send: "SEND PASSWORD RESET"
    }
  }
};
export default login;
